// Core lib dependencies.
import Immutable from 'seamless-immutable';

// Import action types.
import ActionTypes from './actionTypes.js';

// Config.
import Config from './config/config.js';

// Initial state.
var initialState = Immutable({
  isVoting:           false,
  votes:              {},
  showPostVoteCTA:    false,
  postVoteCTAContent: null,
  showDynRecaptcha:   false,
  message:            null,
});

/**
 * <pre>
 * Voting module Reducer(s).
 *
 * Summary of responsibilities:
 *
 *  - responds to actions, receives current Redux state and modifies it accordingly.
 *
 * FYI:
 *
 * All {@link https://github.com/reactjs/redux|Redux} state modifications are handled using {@link https://facebook.github.io/immutable-js/|Immutable} objects and methods.
 * DO NOT DIRECTLY MODIFY THE REDUX STATE (Immutable should stop you from doing this, but just in case)!
 * </pre>
 *
 * @see {@link https://github.com/reactjs/redux|Redux Documentation}
 * @see {@link https://facebook.github.io/immutable-js/|Immutable Documentation}
 *
 * @author Tim Loram
 *
 * @memberof module:Voting
 * @namespace
 *
 * @type {Object}
 */
const Reducer = {
  /**
   * Reducer for the voting actions.
   *
   * @param state: 	{object} The current Redux state.
   * @param action: 	{object} The current Redux action object.
   */
  rootReducer: (state = initialState, action) => {
    // Execute the appropriate logic based on the received action type.
    switch (action.type) {
      // Vote.
      case ActionTypes.VOTING:
        state = state.setIn(['isVoting'], true);
        state = state.setIn(['message'], null);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Vote success.
      case ActionTypes.VOTE_SUCCESS:
        state = state.setIn(['votes', action.item.id], action.votes);
        state = state.setIn(['isVoting'], false);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Vote failure.
      case ActionTypes.VOTE_FAILURE:
        state = state.setIn(['isVoting'], false);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Show dynamic Recaptcha.
      case ActionTypes.SHOW_DYN_RECAPTCHA:
        state = state.setIn(['showDynRecaptcha'], true);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Hide dynamic Recaptcha.
      case ActionTypes.HIDE_DYN_RECAPTCHA:
        state = state.setIn(['showDynRecaptcha'], false);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Post vote CTA.
      case ActionTypes.SHOW_POST_VOTE_CTA:
        state = state.set('showPostVoteCTA', true);
        if (!!action.ctaContent) {
          state = state.setIn(['postVoteCTAContent'], action.ctaContent);
        }
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Hide post vote CTA.
      case ActionTypes.HIDE_POST_VOTE_CTA:
        state = state.set('showPostVoteCTA', false).setIn(['postVoteCTAContent'], null);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Show message.
      case ActionTypes.SHOW_MESSAGE:
        state = state.setIn(['message'], action.message);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Hide message.
      case ActionTypes.HIDE_MESSAGE:
        state = state.setIn(['message'], null);
        return state;

        break;

      // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
      // Make sure to return a state even if no action was matched!
      default:
        return state;
    }
  },
};

export default Reducer;
